import request from '../utils/request';
import type { ArticlePost, ArticleListResponse, ApiResponse } from '@/types';

export const getArticleList = (params: Record<string, unknown> = {}): Promise<ApiResponse<ArticleListResponse>> => {
  return request.get('/blog/articles', { params }) as Promise<ApiResponse<ArticleListResponse>>;
};

export const getArticleById = (postsId: number): Promise<ApiResponse<ArticlePost>> => {
  return request.get(`/blog/article/${postsId}`) as Promise<ApiResponse<ArticlePost>>;
};

export const updateArticleView = (postsId: number): Promise<ApiResponse<null>> => {
  return request.post('/blog/article/view', { postsId }) as Promise<ApiResponse<null>>;
};

/** 文章管理 API（后台） */
export const articleManageAPI = {
  /** 创建文章 */
  create: (data: {
    title: string;
    summary: string;
    content: string;
    isPublish?: boolean;
    isFeatured?: boolean;
    tag?: string;
  }): Promise<ApiResponse<{ id: number }>> =>
    request.post('/blog/create', data) as Promise<ApiResponse<{ id: number }>>,

  /** 更新文章 */
  update: (postsId: number, data: Record<string, unknown>): Promise<ApiResponse<null>> =>
    request.post('/blog/update', { postsId, ...data }) as Promise<ApiResponse<null>>,

  /** 删除文章 */
  delete: (postsId: number): Promise<ApiResponse<null>> =>
    request.post('/blog/delete', { postsId }) as Promise<ApiResponse<null>>,
};
